import React, { useMemo } from 'react';
import styles from '@/common/containers/UserIntro/styles.less';
import {
  First,
  Second,
  Third,
  Fourth,
  Fifth,
} from '@/common/containers/UserIntro/components/index';
import StepperProvider from '@/common/components/Stepper/StepperContext';
import { useStepperContext, useToggle } from '@/common/hooks/index';
import Button from '@mui/material/Button';
import ConfirmModal from '@/common/containers/Modals/ConfirmModal/index';
import cx from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

const screens = [First, Second, Third, Fourth, Fifth];
const STEPS = ['1', '2', '3', '4', '5'];

const StyledUserIntro = ({ className, onFinish }) => {
  const { t } = useTranslation();
  const { nextStep, prevStep, currentStepInd, backToStart } =
    useStepperContext();

  const Screen = useMemo(() => {
    return screens[currentStepInd] || null;
  }, [currentStepInd]);

  return (
    <div className={cx(styles.container, className)}>
      <Screen />
      <div className={styles.footer}>
        {currentStepInd > 0 && (
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={prevStep}
            className={styles.footerBackBtn}
          >
            {t('Back')}
          </Button>
        )}
        <div className={styles.footerBtnWrap}>
          <ConfirmModal
            title={t('You’re almost there!')}
            description={
              <>
                <Trans
                  i18nKey="The next step is to fill in the basic information about the decedent. After that, you can proceed with <1>Immediate tasks</1> module."
                  components={{ 1: <b /> }}
                />
              </>
            }
            confirmText={t('Continue')}
            cancelText={t('Cancel')}
          >
            {(confirm) => (
              <Button
                variant="contained"
                size="large"
                type="success"
                className={styles.footerContinueBtn}
                onClick={
                  currentStepInd === STEPS.length - 1
                    ? onFinish
                      ? confirm(onFinish)
                      : backToStart
                    : nextStep
                }
              >
                {currentStepInd === STEPS.length - 1
                  ? onFinish
                    ? t('Finish onboarding')
                    : t('Back to start')
                  : t('Continue')}
              </Button>
            )}
          </ConfirmModal>
        </div>
      </div>
    </div>
  );
};

const UserIntro = (props) => {
  return (
    <StepperProvider steps={STEPS}>
      <StyledUserIntro {...props} />
    </StepperProvider>
  );
};
export default UserIntro;
